(function () {
    'use strict';
    angular.module('app').factory('moduleURLs',
        function () {
            return {
                envUrl: '/environment/environmentsetup',
                sysUrl: '/system/systemmanager',
                bpUrl: '/general/businesspartner',
                jobUrl: '/general/job',
				productUrl: '/inventory/inventorysetup',
				transUrl: '/inventory/inventorymanagement/transactions',
                orderUrl: '/orderentry',
                prdUrl: '/processing',
                schedUrl: '/scheduling',
                shipUrl: '/shipping',
                trkUrl: '/tracking',
                cadUrl: '/cad',
                glUrl: '/generalLedger',
                invoiceUrl: '/invoice',
                estUrl: '/estimating',
                projPriceUrl: '/projectpricing'
            };

        }
    );
})();